import { component } from 'picoapp';
import Video from 'utils/embedvideo';

export default component(async (node) => {
  const videoURL = node.dataset.videoUrl;
  const videoId = videoURL.split('/').at(-1).replace('watch?v=', '');
  const type = videoURL.includes('vimeo') ? 'vimeo' : 'youtube';

  const videoPlayer = Video({
    container: node,
    type,
    videoId,
  });

  const observer = new IntersectionObserver((entires) => {
    entires.forEach((entry) => {
      if (entry.isIntersecting) {
        videoPlayer.init();
        observer.disconnect();
      }
    });
  });

  observer.observe(node);
});
